
export default function Locations() {
  const locations = [
    {
      city: 'Dallas',
      areas: ['Downtown Dallas', 'Uptown', 'Oak Lawn', 'Deep Ellum', 'Lake Highlands'],
      icon: 'ri-building-line'
    },
    {
      city: 'Fort Worth',
      areas: ['Downtown Fort Worth', 'Sundance Square', 'Cultural District', 'West 7th', 'Alliance'],
      icon: 'ri-community-line'
    },
    {
      city: 'Arlington',
      areas: ['Entertainment District', 'Arlington Highlands', 'Pantego', 'Dalworthington Gardens'],
      icon: 'ri-home-office-line'
    },
    {
      city: 'Plano',
      areas: ['Legacy West', 'West Plano', 'East Plano', 'Willow Bend', 'Parker Road Corridor'],
      icon: 'ri-building-2-line'
    },
    {
      city: 'Irving',
      areas: ['Las Colinas', 'Valley Ranch', 'DFW Airport Area', 'North Irving', 'South Irving'],
      icon: 'ri-store-2-line'
    },
    {
      city: 'Frisco',
      areas: ['The Star', 'Frisco Square', 'Stonebriar', 'West Frisco', 'East Frisco'],
      icon: 'ri-building-4-line'
    }
  ];

  return (
    <section id="locations" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-sm font-semibold text-orange-600 tracking-widest uppercase mb-4 block">
            Service Areas
          </span>
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Serving the Entire<br />DFW Metroplex
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We provide premium vending machine services across all major cities and communities in the Dallas-Fort Worth area
          </p>
        </div>

        <div className="mb-16">
          <div className="w-full h-96 rounded-3xl overflow-hidden shadow-2xl">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d429156.68397009677!2d-97.04034984999999!3d32.820664!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c19f77b45974b%3A0xb9ec9ba4f647678f!2sDallas-Fort%20Worth%2C%20TX!5e0!3m2!1sen!2sus!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="DFW Service Area Map"
            ></iframe>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {locations.map((location, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white border-2 border-gray-100 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="flex items-start justify-between mb-6">
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{location.city}</h3>
                  <div className="flex items-center text-orange-600">
                    <div className="w-5 h-5 flex items-center justify-center mr-2">
                      <i className="ri-checkbox-circle-fill text-base"></i>
                    </div>
                    <span className="text-sm font-medium">Full Coverage</span>
                  </div>
                </div>
                <div className="w-14 h-14 flex items-center justify-center bg-orange-100 rounded-full">
                  <i className={`${location.icon} text-orange-600 text-2xl`}></i>
                </div>
              </div>

              <div className="space-y-2">
                <p className="text-sm font-semibold text-gray-700 mb-3">Coverage Areas:</p>
                {location.areas.map((area, areaIndex) => (
                  <div key={areaIndex} className="flex items-center text-sm text-gray-600">
                    <div className="w-1.5 h-1.5 bg-orange-600 rounded-full mr-3"></div>
                    <span>{area}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-orange-500 to-orange-600 rounded-3xl p-12 text-center text-white shadow-2xl">
          <h3 className="text-3xl font-bold mb-4">Don't See Your Area?</h3>
          <p className="text-lg text-orange-100 mb-8 max-w-2xl mx-auto">
            We're constantly expanding our service coverage. Contact us to discuss bringing premium vending solutions to your location.
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-white text-orange-600 px-8 py-4 rounded-full text-base font-semibold hover:bg-gray-100 transition-colors shadow-lg cursor-pointer whitespace-nowrap"
          >
            Contact Us Today
          </button>
        </div>
      </div>
    </section>
  );
}
